import React from "react";
import {useFormContext} from "react-hook-form";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import * as CustomStyles from '../styles/CustomStyles';
import * as ValidationMessages from '../constants/ValidationMessages';
import * as DataPattern from '../constants/DataPattern';
import {getRoleDescription} from '../util/TypeConvertor';
import * as Consts from '../constants/Consts';

//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lEmployee is expected to be in the local form state
//



export function RenderPersonalDataSection() {
    const { register, formState: { errors, defaultValues } } = useFormContext();

    const clientName = defaultValues.lUser.generalSection.clientId === Consts.COREVO_CLIENT_ID ? Consts.COREVO_CLIENT_NAME : defaultValues.lClient?.generalSection?.clientName;

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume Utilizator (Email)" value={defaultValues.lUser.generalSection.username} fullWidth margin="dense" disabled />
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume" fullWidth margin="dense"
                        {...register("lUser.generalSection.lastName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.generalSection?.lastName}
                        helperText={errors?.lUser?.generalSection.lastName ? errors.lUser.generalSection.lastName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Prenume" fullWidth margin="dense"
                        {...register("lUser.generalSection.firstName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.generalSection?.firstName}
                        helperText={errors?.lUser?.generalSection?.firstName ? errors.lUser.generalSection.firstName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Angajat de" value={clientName} fullWidth margin="dense" disabled />
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Rol" value={ getRoleDescription(defaultValues.lUser.generalSection.role) } fullWidth margin="dense" disabled />
                </Grid>
                <Grid item xs={8}>
                </Grid>

            </Grid>
        </Box>
    );
}




export function RenderPasswordSection() {
    const { register, getValues, formState: { errors, defaultValues } } = useFormContext();

    const [showOldPassword, setShowOldPassword] = React.useState(false);
    const [showNewPassword, setShowNewPassword] = React.useState(false);
    const [showPasswordConf, setShowPasswordConf] = React.useState(false);

    const handleClickShowOldPassword = () => setShowOldPassword(!showOldPassword);
    const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
    const handleClickShowPasswordConf = () => setShowPasswordConf(!showPasswordConf);


    const validatePasswordMatch = (passwordConf) => {
        const password = getValues('lUser.passwordSection.newPassword');
        if(password && password !== passwordConf) {
            return ValidationMessages.PWD_AND_PWD_CONF_MISMATCH;
        }
        else {
            return true;
        }
    }

    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Parola Veche" fullWidth margin="dense" 
                        type={showOldPassword ? "text" : "password"} 
                        autoComplete='off'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowOldPassword}
                                    >
                                        {!showOldPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
    
                        {...register("lUser.passwordSection.oldPassword", 
                            {required: ValidationMessages.REQUITED_MESSAGE,
                             pattern: {
                                value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT,
                            }  
                            }
                        )}
                        error={!!errors?.lUser?.passwordSection?.oldPassword}
                        helperText={errors?.lUser?.passwordSection?.oldPassword ? errors.lUser.passwordSection.oldPassword.message : null}
                    />
                </Grid>
                <Grid item xs={7}>
                </Grid>

                {/*row*/}
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Parola" fullWidth margin="dense"
                        type={showNewPassword ? "text" : "password"} 
                        autoComplete='off'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowNewPassword}
                                    >
                                        {!showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}

                        {...register("lUser.passwordSection.newPassword", 
                            {required: ValidationMessages.REQUITED_MESSAGE,
                             pattern: {
                                value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT,
                            }  
                            }
                        )} 
                        error={!!errors?.lUser?.passwordSection?.newPassword}
                        helperText={errors?.lUser?.passwordSection?.newPassword ? errors.lUser.passwordSection.newPassword.message : null}
                    />
                </Grid>
                <Grid item xs={7}>
                </Grid>

                {/*row*/}
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Confirmare Parola" fullWidth margin="dense"
                        type={showPasswordConf ? "text" : "password"} 
                        autoComplete='off'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPasswordConf}
                                    >
                                        {!showPasswordConf ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        {...register("lUser.passwordSection.passwordConf", 
                            {required: ValidationMessages.REQUITED_MESSAGE,
                             pattern: {
                                value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT
                            },  
                            validate: validatePasswordMatch
                        }
                        )} 
                        error={!!errors?.lUser?.passwordSection?.passwordConf}
                        helperText={errors?.lUser?.passwordSection?.passwordConf ? errors.lUser.passwordSection.passwordConf.message : null}
                    />
                </Grid>
                <Grid item xs={7}>
                </Grid>

            </Grid>
        </Box>
    );
}